import { t } from "@lingui/macro";

// Native sends only stable, non-display keys for a missing write type (never English text) — the
// copy naming them is authored and translated here.
const writeTypeName = (key: string): string => {
  switch (key) {
    case "heartRate":
      return t`Heart Rate`;
    case "activeEnergy":
      return t`Active Energy`;
    case "distanceCycling":
      return t`Cycling Distance`;
    case "distanceWalkingRunning":
      return t`Walking + Running Distance`;
    case "route":
      return t`Workout Routes`;
    case "workout":
      return t`Workouts`;
    default:
      return key;
  }
};

// Locale-formatted list join (not a hardcoded ", "/"and") since this renders in every supported
// locale. Returns undefined when there's nothing to name, so callers can fall back to generic copy.
export const formatMissingWriteTypeList = (keys: string[] | undefined): string | undefined => {
  const names = (keys ?? []).map(writeTypeName);
  return names.length > 0
    ? new Intl.ListFormat(undefined, { style: "long", type: "conjunction" }).format(names)
    : undefined;
};
